import { memo } from "react";

import { Typography } from "neetoui";
import { Trans } from "react-i18next";

import { useShowCurrentIp } from "./hooks/reactQuery/useCurrentIp";

const CurrentIp = () => {
  const { data, isLoading } = useShowCurrentIp();

  return (
    <div
      className="flex flex-wrap items-baseline gap-1"
      data-testid="current-ip-container"
    >
      <Typography>
        <Trans
          i18nKey="neetoMolecules.ipRestriction.currentIpMessage"
          values={{ ip: isLoading ? "..." : data.ip }}
        />
      </Typography>
    </div>
  );
};

export default memo(CurrentIp);
